// Central, authoritative tooltip-copy map for the Booking Pace dashboard.
// Keyed by the EXACT StatsCard title string rendered on the page. The page looks up
// `bookingPaceTooltips[title]` and threads it into each card's `tooltip` prop.
// Canonical copy lives in .verified/features/booking-pace-extra-metrics/ui-spec.md
// ("Tooltip copy — central map"); transcribe verbatim.
export const bookingPaceTooltips: Record<string, string> = {
  // Shared / All Sources
  "Gross Income":
    "Total gross income from bookings made during the selected period.",
  "Days Booked":
    "Total nights booked across reservations made during the selected period.",
  "Bookings Received":
    "Counts every reservation created during the selected period, except one with no nights and no income. A cancellation still counts if money changed hands — a fee kept, or a refund.",
  "Bookings Cancelled":
    "Reservations cancelled during the selected period, counted by cancellation date.",
  "Days Cancelled":
    "Total nights from reservations cancelled during the selected period.",
  "Average Daily Cancellation Rate":
    "Nights cancelled per day in the period (days cancelled ÷ number of days in the period).",
  "Cancellation Rate":
    "Cancellation pressure this period: nights cancelled ÷ nights booked. Cancellations are counted by cancel date and bookings by booking date, so this can exceed 100%.",
  "Booking Cancellation Rate":
    "Cancellation pressure this period: bookings cancelled ÷ bookings received. Cross-axis (cancel date vs booking date), so this can exceed 100%. A cancellation where money changed hands counts in both the top and the bottom number.",
  "Bookings Per Property":
    "Bookings received ÷ the number of properties operational during the period. Normalizes booking volume for portfolio size so year-over-year is comparable (more apartments alone would inflate the daily booking rate).",
  "Average Daily Booking Rate":
    "Nights booked per day in the period (days booked ÷ number of days in the period).",
  "Future Days Booked":
    "Booked nights in the period that fall on future dates (after today).",
  "Current Month - Days Booked":
    "Booked nights in the period that fall on or before today (days booked − future days booked).",
  "Current Net Income":
    "Net income from the portion of bookings dated on or before today.",
  "Current Gross Adr":
    "Average gross nightly rate for booked nights on or before today.",
  "Current Net Adr":
    "Average net nightly rate for booked nights on or before today.",
  "Future Net Income":
    "Net income from the portion of bookings dated in the future.",
  "Future Gross Adr": "Average gross nightly rate for future booked nights.",
  "Future Net Adr": "Average net nightly rate for future booked nights.",

  // Per-platform-only titles
  "Gross Income - Current Days":
    "This platform's gross income from bookings dated on or before today.",
  "Gross Income - Future Days":
    "This platform's gross income from bookings dated in the future.",
  "Days Booked - Current Days":
    "This platform's booked nights dated on or before today.",
  "Days Booked - Future Days":
    "This platform's booked nights dated in the future.",
  "Net Income - Current Days":
    "This platform's net income from bookings dated on or before today.",
  "Gross Adr - Current Days":
    "This platform's average gross nightly rate for nights on or before today.",
  "Net Adr - Current Days":
    "This platform's average net nightly rate for nights on or before today.",
  "Net Income - Future Days":
    "This platform's net income from bookings dated in the future.",
  "Gross Adr - Future Days":
    "This platform's average gross nightly rate for future nights.",
  "Net Adr (Future Days)":
    "This platform's average net nightly rate for future nights.",
};
